import { render } from "./ConfirmationSave.vue?vue&type=template&id=329cd74d&scoped=true&ts=true"
import script from "./ConfirmationSave.vue?vue&type=script&lang=ts"
export * from "./ConfirmationSave.vue?vue&type=script&lang=ts"

import "./ConfirmationSave.vue?vue&type=style&index=0&id=329cd74d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-329cd74d"]])

export default __exports__